import jpg from '../../assets/kirjautuminen.jpg';
import webp from '../../assets/kirjautuminen.webp';
import webpSmall from '../../assets/kirjautuminen-900.webp';
import s from './auth.module.css';

/**
 * Kirjautumissivun kuva: iltainen kerrostaloalue, jonka ikkunoissa palaa valo, ja taustalla
 * Turun, Tampereen ja Helsingin siluetit. Kuva rajautuu paneelin muotoon (object-fit: cover)
 * niin, että kerrostalot pysyvät näkyvissä.
 */
export function Facade() {
  return (
    <picture>
      <source type="image/webp" srcSet={`${webpSmall} 900w, ${webp} 1402w`} sizes="55vw" />
      <img className={s.facade} src={jpg} alt="" width={1402} height={1122} decoding="async" />
    </picture>
  );
}
